export type MobileLayout =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15;

export const DEFAULT_MOBILE_LAYOUT: MobileLayout = 15;
export const EXPLORE_FILTERS_SEGMENT = "filters";

const EMPTY_TAG_SEGMENT = "__all";

const MOBILE_LAYOUTS = new Map<string, MobileLayout>([
  ["1", 1],
  ["2", 2],
  ["3", 3],
  ["4", 4],
  ["5", 5],
  ["6", 6],
  ["7", 7],
  ["8", 8],
  ["9", 9],
  ["10", 10],
  ["11", 11],
  ["12", 12],
  ["13", 13],
  ["14", 14],
  ["15", 15],
]);

export function parseTagSlugs({
  searchParams,
}: {
  searchParams: URLSearchParams;
}): string[] {
  const rawValue = searchParams.get("tags");
  if (!rawValue) {
    return [];
  }

  return rawValue.split(",").filter(Boolean);
}

export function parseMobileLayout({
  searchParams,
}: {
  searchParams: URLSearchParams;
}): MobileLayout {
  const rawValue = searchParams.get("v");
  if (!rawValue) {
    return DEFAULT_MOBILE_LAYOUT;
  }

  return MOBILE_LAYOUTS.get(rawValue) ?? DEFAULT_MOBILE_LAYOUT;
}

export function encodeExploreFilterTagSegment({
  tagSlugs,
}: {
  tagSlugs: string[];
}): string {
  return tagSlugs.length > 0 ? tagSlugs.join(",") : EMPTY_TAG_SEGMENT;
}

export function decodeExploreFilterTagSegment({
  segment,
}: {
  segment: string;
}): string[] {
  if (segment === EMPTY_TAG_SEGMENT) {
    return [];
  }

  return segment.split(",").filter(Boolean);
}

export function buildExploreSearch({
  tagSlugs,
  mobileLayout,
}: {
  tagSlugs: string[];
  mobileLayout: MobileLayout;
}): string {
  const searchParams = new URLSearchParams();

  if (tagSlugs.length > 0) {
    searchParams.set("tags", tagSlugs.join(","));
  }

  if (mobileLayout !== DEFAULT_MOBILE_LAYOUT) {
    searchParams.set("v", `${mobileLayout}`);
  }

  return searchParams.toString();
}
